import React, { useEffect, useState } from "react";
import axios from "axios";
import gsap from "gsap";
import PopCard from "../components/PopCards";
import revealAnimation from "../components/Reveal";
import "../css/component.css";
import Swal from "sweetalert2";

const Resource = ({ resource }) => {
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  const [resourceName, setResourceName] = useState("");
  const [resourceData, setResourceData] = useState([]);
  const [showPopCard, setShowPopCard] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    description: "",
    location: "",
    imgUrl: "",
    resource: resource,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const base_url = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    setResourceName(resource);
    fetchData(); // Fetch data whenever the component mounts or `resource` changes
    revealAnimation();
  }, [resource]);

  useEffect(() => {
    if (resourceData.length > 0) {
      gsap.fromTo(
        ".srs-card",
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          stagger: 0.1,
        }
      );
    }
  }, [resourceData]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${base_url}/resource/type/${resource}`);
      setResourceData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddOrEdit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await axios.put(`${base_url}/resource/${formData.id}`, formData);
        Swal.fire("Success", "Resource updated successfully!", "success");
      } else {
        await axios.post(`${base_url}/resource/add`, formData);
        Swal.fire("Success", "New resource added successfully!", "success");
      }
      fetchData();
      setFormData({
        id: "",
        name: "",
        description: "",
        location: "",
        imgUrl: "",
        resource: resource,
      });
      setIsEditing(false);
      setShowForm(false);
    } catch (error) {
      Swal.fire("Error", "Error saving resource. Please try again.", "error");
      console.error("Error saving resource:", error);
    }
  };

  const handleEdit = (item) => {
    setFormData(item);
    setIsEditing(true);
    setShowForm(true);
  };

  const handleDelete = async (id, name) => {
    Swal.fire({
      title: `Are you sure to delete ${name}?`,
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${base_url}/resource/delete`, { data: { id } });
          Swal.fire("Deleted!", `${name} has been deleted.`, "success");
          fetchData();
        } catch (error) {
          Swal.fire(
            "Error",
            "Error deleting resource. Please try again.",
            "error"
          );
          console.error("Error deleting resource:", error);
        }
      }
    });
  };

  const handleDownloadClick = (name, location) => {
    setShowPopCard(true);
    window.open(location, "_blank", "noopener,noreferrer");
    Swal.fire("Info", `Downloading ${name}...`, "info");
  };

  const handleClosePopCard = () => {
    setShowPopCard(false);
  };

  const handleAddNew = () => {
    setFormData({
      id: "",
      name: "",
      description: "",
      location: "",
      imgUrl: "",
      resource: resource,
    });
    setIsEditing(false);
    setShowForm(true);
  };

  return (
    <>
      <div className="home">
        <h1 className="reveal">{resourceName}</h1>
        {showPopCard && <PopCard onClose={handleClosePopCard} />}
        {isAdmin ? (
          <button onClick={handleAddNew} className="btn2 btn-add">
            Add New {resource}
          </button>
        ) : null}

        {showForm && (
          <form onSubmit={handleAddOrEdit} className="form-container">
            
            <input
              type="text"
              name="id"
              value={formData.id}
              onChange={handleFormChange}
              placeholder="ID"
              required
              className="form-input"
            />
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleFormChange}
              placeholder={`${resource} Name`}
              required
              className="form-input"
            />
            <textarea
              name="description"
              value={formData.description}
              onChange={handleFormChange}
              placeholder="Description"
              className="form-input"
            />
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleFormChange}
              placeholder="Location URL"
              className="form-input"
            />
            <input
              type="text"
              name="imgUrl"
              value={formData.imgUrl}
              onChange={handleFormChange}
              placeholder="Image URL"
              className="form-input"
            />
            <input
              type="file"
              name="imgUrl"
              // value={formData.imgUrl}
              // onChange={handleFormChange}
              placeholder="Image URL"
              className="form-input"
            />
            <div className="button-group">
              <button type="submit" className="btn btn2">
                {isEditing ? "Update" : "Add"} {resource}
              </button>
              <button
                type="button"
                onClick={() => setShowForm(false)}
                className="btn btn1"
              >
                Cancel
              </button>
            </div>
          </form>
        )}
        <div className="display-cards">
          {resourceData.map((item) => (
            <div key={item.id} className="srs-card">
              <div className="srs-card-right">
                <h2>{item.name}</h2>
                <p>{item.description}</p>
              </div>
              <button
                onClick={() => handleDownloadClick(item.name, item.location)}
                className="btn2 btn-dwnld"
              >
                Download
              </button>
              {isAdmin ? (
                <>
                  <button
                    onClick={() => handleEdit(item)}
                    className="btn2 btn-edit"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(item.id, item.name)}
                    className="btn2 btn-delete"
                  >
                    Delete
                  </button>
                </>
              ) : null}
              {item.imgUrl && (
                <div className="srs-img">
                  <img
                    src={require(`../assets/${item.imgUrl}.png`)}
                    alt={item.name}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Resource;
